import { getProductName } from "@/lib/config";
import { cn } from "@/lib/utils";

interface LogoProps {
  size?: 'default' | 'lg';
}

export default function Logo({ size = 'default' }: LogoProps) {
  const productName = getProductName();
  return (
    <span className={cn(
      "font-medium tracking-tighter text-foreground inline-block",
      size === 'lg' ? 'text-4xl' : 'text-2xl'
    )}>{productName}</span>
  );
}

